export default "__VITE_ASSET__U4M0iJh0__"